import EKGPreview from './EKGPreview';

export default EKGPreview;
